import Image from '@atlaskit/image';
import panelAnatomyLight from "../../../../../../packages/design-system/panel-system/constellation/index/images/panel-anatomy-light.png";
import panelAnatomyDark from "../../../../../../packages/design-system/panel-system/constellation/index/images/panel-anatomy-dark.png";
import headerSubheaderAnatomyLight from "../../../../../../packages/design-system/panel-system/constellation/index/images/header-subheader-anatomy-light.png";
import headerSubheaderAnatomyDark from "../../../../../../packages/design-system/panel-system/constellation/index/images/header-subheader-anatomy-dark.png";
import headerTypesLight from "../../../../../../packages/design-system/panel-system/constellation/index/images/header-types-light.png";
import headerTypesDark from "../../../../../../packages/design-system/panel-system/constellation/index/images/header-types-dark.png";
import modalDoLight from "../../../../../../packages/design-system/panel-system/constellation/index/images/modal-do-light.png";
import modalDoDark from "../../../../../../packages/design-system/panel-system/constellation/index/images/modal-do-dark.png";
import modalDontLight from "../../../../../../packages/design-system/panel-system/constellation/index/images/modal-dont-light.png";
import modalDontDark from "../../../../../../packages/design-system/panel-system/constellation/index/images/modal-dont-dark.png";
import headerTitleDoLight from "../../../../../../packages/design-system/panel-system/constellation/index/images/header-title-do-light.png";
import headerTitleDoDark from "../../../../../../packages/design-system/panel-system/constellation/index/images/header-title-do-dark.png";
import headerTitleDontLight from "../../../../../../packages/design-system/panel-system/constellation/index/images/header-title-dont-light.png";
import headerTitleDontDark from "../../../../../../packages/design-system/panel-system/constellation/index/images/header-title-dont-dark.png";
import * as React from 'react';
export default {
  Image,
  panelAnatomyLight,
  panelAnatomyDark,
  headerSubheaderAnatomyLight,
  headerSubheaderAnatomyDark,
  headerTypesLight,
  headerTypesDark,
  modalDoLight,
  modalDoDark,
  modalDontLight,
  modalDontDark,
  headerTitleDoLight,
  headerTitleDoDark,
  headerTitleDontLight,
  headerTitleDontDark,
  React
};